import React, { useRef } from 'react';
import { Search, SlidersHorizontal, X } from 'lucide-react';

export const ProductsToolbar = ({
    searchTerm,
    onSearchChange,
    sortBy,
    onSortChange,
    categories,
    selectedCategory,
    onCategorySelect,
    onClearFilters,
    loadingCategories,
    rtl = true
}) => {
    const scrollRef = useRef(null);

    return (
        <div className="space-y-4 animate-fadein" dir={rtl ? 'rtl' : 'ltr'}>
            {/* Top Row: Search + Sort */}
            {/* <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex-1 relative group">
                    <Search className="absolute top-1/2 -translate-y-1/2 right-3 w-5 h-5 text-mekomit-400 pointer-events-none" />
                    <input
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        placeholder="חיפוש מוצרים..."
                        className="w-full bg-white/90 backdrop-blur border border-mekomit-200 focus:border-mekomit-400 focus:ring-2 focus:ring-mekomit-300/60 rounded-2xl py-3 pr-11 pl-4 text-mekomit-900 placeholder-mekomit-400 text-sm sm:text-base outline-none transition shadow-sm focus:shadow-md"
                        aria-label="חיפוש"
                    />
                    {searchTerm && (
                        <button
                            onClick={() => onSearchChange('')}
                            className="absolute left-3 top-1/2 -translate-y-1/2 text-mekomit-500 hover:text-mekomit-700 transition"
                            aria-label="נקה חיפוש"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    )}
                </div>
                <div className="flex items-stretch gap-2">
                    <div className="relative">
                        <select
                            value={sortBy}
                            onChange={(e) => onSortChange(e.target.value)}
                            className="appearance-none bg-white/90 backdrop-blur border border-mekomit-200 focus:border-mekomit-400 focus:ring-2 focus:ring-mekomit-300/60 rounded-2xl py-3 px-4 pr-10 text-mekomit-900 text-sm sm:text-base outline-none transition shadow-sm focus:shadow-md cursor-pointer"
                            aria-label="מיין לפי"
                        >
                            <option value="popular">פופולרי</option>
                            <option value="price_asc">מחיר (נמוך→גבוה)</option>
                            <option value="price_desc">מחיר (גבוה→נמוך)</option>
                            <option value="new">חדש</option>
                            <option value="name">שם</option>
                        </select>
                        <SlidersHorizontal className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-mekomit-400" />
                    </div>
                    {(searchTerm || selectedCategory || sortBy !== 'popular') && (
                        <button
                            onClick={onClearFilters}
                            className="px-4 py-3 rounded-2xl bg-mekomit-100 text-mekomit-700 border border-mekomit-200 hover:bg-mekomit-200 hover:text-mekomit-900 text-sm font-semibold transition shadow-sm"
                        >
                            איפוס
                        </button>
                    )}
                </div>
            </div> */}

            {/* Categories Row */}
            <div
                ref={scrollRef}
                className="flex gap-2 overflow-x-auto scrollbar-thin scrollbar-thumb-mekomit-200 scrollbar-track-transparent pb-1 -mx-1 px-1"
                aria-label="קטגוריות"
            >
                <button
                    onClick={() => onCategorySelect(null)}
                    className={`flex-shrink-0 px-4 py-2 rounded-full font-semibold text-sm transition-all border ${selectedCategory === null ? 'bg-mekomit-500 text-white border-mekomit-500 shadow' : 'bg-white text-mekomit-800 border-mekomit-200 hover:bg-mekomit-100'} focus:outline-none focus-visible:ring-2 focus-visible:ring-mekomit-400`}
                >
                    הכל
                </button>
                {loadingCategories && (
                    <div className="flex items-center text-mekomit-500 text-sm">טוען...</div>
                )}
                {!loadingCategories && categories?.map(cat => (
                    <button
                        key={cat.category_id}
                        onClick={() => onCategorySelect(cat.category_id)}
                        className={`flex-shrink-0 px-4 py-2 rounded-full font-semibold text-sm transition-all border ${selectedCategory === cat.category_id ? 'bg-mekomit-500 text-white border-mekomit-500 shadow' : 'bg-white text-mekomit-800 border-mekomit-200 hover:bg-mekomit-100'} focus:outline-none focus-visible:ring-2 focus-visible:ring-mekomit-400`}
                    >
                        {cat.name}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ProductsToolbar;